import React, {Component} from "react";
import Action from 'components/organisms/nhl-legacy-team-stacking/actions';
import {connect} from "react-redux";

class MirrorStack extends Component {
    onChange() {
        this.props.dispatch(Action.mirrorStack(
            this.props.sourceStackNumber,
            this.props.destinationStackNumber,
        ));
    }

    render() {
        const sourceStackNumber = this.props.sourceStackNumber;

        return (
            <button
                type="button"
                className="btn-mirror"
                onClick={e => ::this.onChange(e)}
            >Mirror Stack {sourceStackNumber}</button>
        );
    }
}

export default connect(() => ({}))(MirrorStack);